import { useAppQuery } from '@/helpers/api/query'
import { format } from 'date-fns'

import { createInstance } from '@/helpers/api/base'
import { useDateStore } from '@/components/DateInput'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { VehicleAllocation } from '@/types/vehicleAllocation'

const GET_VEHICLE_ALLOCATION_KEY = 'GET_VEHICLE_ALLOCATION'

export const useGetVehicleAllocation = () => {
    const { routes } = useWorkstationStore()
    const { date } = useDateStore()
    const formattedDate = format(date, 'yyyy/MM/dd')
    const routesToLoad = routes.map((route) => route.route)

    return useAppQuery<{ vehicleAssignments: VehicleAllocation[] }>({
        queryKey: [GET_VEHICLE_ALLOCATION_KEY, formattedDate, routesToLoad],
        queryFn: ({ queryKey }) =>
            createInstance({
                url: '/fleets/vehicle-allocation',
                method: 'GET',
                params: {
                    Date: queryKey[1],
                    Routes: queryKey[2],
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        refetchOnMount: 'always',
    })
}
